const REST_API_SHS_ASURION =
  globals.NODE_ENV === 'production'
    ? {
        URL: {
          v1Testimonials: 'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/csdbproxy',
          vhtAddAppointment: 'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId: 'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://xg8g0ffd73.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertFeedbackEmails',
          unsubscribe: 'https://f65v6lll19.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6Le83qoUAAAAAEHyjx00nhzzxUlYG1j702XwfYbK',
          mixpanelApiKey: 'Yc7nr43fsJaJbGAm5gpMtbxvHVh8RxY7DrEqqXyP',
          mixpanelSource: 'shs-experiences',
          carrier: 'asurion',
          scope: 'SHS_EXPERT_SESSIONS',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      }
    : {
        URL: {
          v1Testimonials: 'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/testimonials',
          submitClaim: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/claimstool',
          validateStore: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/validatestore',
          retrieveStoreStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/storestats',
          retrieveUserStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/userstats',
          dashboardStats: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/dashboardstats',
          listAllAppointments: '',
          editAppointment: '',
          cancelAppointment: '',
          createAppointment:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertCustomerData',
          usedAppointmentTimeSlots:
            'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/timestamp',
          csdb: 'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/csdbproxy',
          vhtAddAppointment: 'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/updatevht',
          vhtGetNextAvailableAppointmentTime:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/fetchtimeslotsfromvht',
          experiencesVhtGetNextAvailableAppointmentTime:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/fetchtimeslotsfromvht',
          sendV1IdAndVhtId:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/updateCustomerData',
          feedback: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/feedback',
          reporting:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/sendreportingevents',
          getAppointment: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbyid',
          getAtlasId: 'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/getUniversalId',
          retrieveQuotesAndTips: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/quotes',
          getCustomerByMdn: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/getcustomerbymdn',
          survey: 'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/suggesttopic',
          joinResearch: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/ccappstoreagentqa/joinresearch',
          decrypt: 'https://1hvruscv02.execute-api.us-east-1.amazonaws.com/v1/decrypt',
          fonoApiUrl: 'https://fonoapi.freshpixl.com/v1/getdevice',
          leaderBoard: 'https://53020nhmrc.execute-api.us-east-1.amazonaws.com/v1/leaderboard',
          campaignDetails:
            'https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/notificationdetails?id=',
          expertSessionsAppointment:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/getappointmentinfo',
          expertSessionsFeedback:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertSurveyResponse',
          expertSessionsJoinResearch:
            'https://m2efn39in7.execute-api.us-east-1.amazonaws.com/Asurion-Experiences/v3/insertFeedbackEmails',
          unsubscribe: ' https://u8hgm6aw99.execute-api.us-east-1.amazonaws.com/v1/vzw/campaign/v1/unsubscribe',
        },
        KEY: {
          recaptcha: '6Le83qoUAAAAAEHyjx00nhzzxUlYG1j702XwfYbK',
          mixpanelApiKey: 'Yc7nr43fsJaJbGAm5gpMtbxvHVh8RxY7DrEqqUbW',
          mixpanelSource: 'shs-experiences',
          carrier: 'asurion',
          scope: 'SHS_EXPERT_SESSIONSQA',
        },
        VHTSEGMENT: {
          mysheduleSegment: {
            key: 'ATT.en-us.Soluto_Mega1.',
            value: 'ATT_MPC',
          },
        },
      };

export default REST_API_SHS_ASURION;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/config/restApi.SHS-ASURION.js